import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { getTokenData } from 'storage';
// eslint-disable-next-line no-undef
window.Pusher = Pusher;

class WS {
  constructor() {
    this.instance = null;
    this.token = null;
  }

  get ws() {
    return this.instance;
  }

  connect() {
    const token = this.token ?? getTokenData()?.access_token;

    if (!token) {
      // eslint-disable-next-line no-console
      console.warn('No token available for WebSocket connection');
      return null;
    }

    // Prevent duplicate connections with the same token
    if (this.instance && token === this.currentToken) {
      return this.instance;
    }

    this.disconnect();
    this.currentToken = token;

    this.instance = new Echo({
      broadcaster: 'pusher',
      key: import.meta.env.REACT_APP_WS_KEY,
      cluster: import.meta.env.REACT_APP_WS_CLUSTER,
      wsHost: import.meta.env.REACT_APP_WS_HOST,
      wsPort: import.meta.env.REACT_APP_WS_PORT,
      wssPort: import.meta.env.REACT_APP_WS_PORT,
      disableStatus: true,
      enableTransports: ['ws', 'wss'],
      forceTLS: false,
      authEndpoint: `${
        import.meta.env.REACT_APP_BASE_URL
      }api/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      },
    });

    return this.instance;
  }

  setToken(token) {
    this.token = token;

    if (this.instance && token !== this.currentToken) {
      this.connect();
    }
  }

  disconnect() {
    if (this.instance) {
      try {
        this.instance.disconnect();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Error disconnecting from WebSocket:', error);
      }
    }
    this.instance = null;
    this.currentToken = null;
  }
}

const echo = new WS();

export default echo;
